module.exports = __webpack_public_path__ + "static/darlene-8f31bee09dd338f2b0a642d38ad2c6e7.jpg";